import GC from '@grapecity/spread-sheets';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import popupUtil from '@/commons/popupUtil.js';
import commonFn from '@/commons/commonFunction.js';

class MISAWorkbookAvaHelper {
    /**
     * Set data cho workbook
     * @param {*} wb 
     * @param {*} dataTree 
     * @returns 
     */
    setDataByWorkbook(wb, dataTree) {
        const columnLetter = this.getColumnLetter(colIndex);
        return columnLetter + (rowIndexRef + 1);
    }

    /**
     * Add rule cho các cột trong worksheet
     * @param {*} worksheet 
     * @param {*} colIndex 
     * @param {*} rule 
     */
    addRuleToColumnWorksheet(worksheet, colIndex, rule) {

    }

    // Hàm sắp xếp cây dữ liệu
    sortDataTree(data) {
        const map = {}; // Tạo một đối tượng để lưu trữ các phần tử theo id
        const result = []; // Mảng kết quả để lưu trữ các phần tử đã sắp xếp

        // Tạo một bản đồ cho phép truy cập nhanh đến từng mục theo id
        data.forEach(item => {
            map[item.id] = { ...item, children: [] }; // Thêm thuộc tính children để lưu trữ các phần tử con
        });

        // Xây dựng cấu trúc cây
        data.forEach(item => {
            if (item.parent_id) {
                map[item.parent_id].children.push(map[item.id]); // Nếu có parent_id, thêm vào children của phần tử cha
            } else {
                result.push(map[item.id]); // Nếu không có parent_id, thêm vào mảng kết quả
            }
        });

        // Hàm để làm phẳng cấu trúc cây
        const flatten = (nodes) => {
            let flatArray = []; // Mảng để lưu trữ kết quả đã làm phẳng
            nodes.forEach(node => {
                flatArray.push(node); // Thêm phần tử hiện tại vào mảng
                flatArray = flatArray.concat(flatten(node.children)); // Kết hợp các phần tử con vào mảng
            });
            return flatArray; // Trả về mảng đã làm phẳng
        };

        return flatten(result); // Trả về mảng kết quả đã được làm phẳng
    }

    /**
     * sinh ra header columns và dataSources mặc định
     * @param {*} maxGrades 
     * @returns 
     */
    genHeaderColumnsAndDataSources(maxGrades) {

        if (!maxGrades || maxGrades.length === 0) maxGrades = 1;
        const headerColumns = [];
        const dataSources = {
            code: '',
            group: '',
        };
        headerColumns.push({
            name: 'code',
            displayName: 'Mã',
            size: 150,
        });

        for (let i = 0; i < maxGrades; i++) {
            let displayName = 'Tên nhiệm vụ';
            if (i > 0) {
                displayName += ' cấp ' + (i + 1);
            }
            let headerColumn = {
                name: 'name' + (i + 1),
                displayName: displayName,
                size: 450,
                cellType: new GC.Spread.Sheets.CellTypes.Text(),
            };
            dataSources['name' + (i + 1)] = '';
            headerColumns.push(headerColumn);
        }
        let cellType = new GC.Spread.Sheets.CellTypes.ComboBox();
        cellType.items([{ text: i18nEnum.RegularGroup.Regular, value: 1 }, { text: i18nEnum.RegularGroup.NotRegular, value: 2 }, { text: i18nEnum.RegularGroup.AssignedByState, value: 3 }]);
        headerColumns.push({
            name: 'group',
            displayName: 'Nhóm nhiệm vụ',
            size: 200,
            cellType: cellType,
        });
        return { headerColumns: headerColumns, dataSources: [dataSources] };
    }
    // Hàm tìm giá trị grade max
    findMaxGrade(data) {
        if (!data || data.length <= 0) return 0;
        return Math.max(...data.map(obj => obj.grade));
    }

    /**
     * Render mẫu nhập liệu nv cho người dùng
     * @param {*} workbook 
     * @param {*} dataTree 
     */
    renderDataToWorkbook(worksheet, dataTree) {

        const keyMap = {
            row_id: 'id',
            name: 'name',
            regular_code: 'code',
            Grade: 'grade',
            group: 'group',
        }
        dataTree = this.renameKeys(dataTree, keyMap, true);
        const maxGrades = this.findMaxGrade(dataTree);
        const InfoWorkbook = this.genHeaderColumnsAndDataSources(maxGrades);
        const dataSoruce = this.mapDataSourcesByDataTree(dataTree);
        this.addDuplicateRuleColumn(worksheet, 0);
        if (dataSoruce) {
            worksheet.setDataSource(dataSoruce);
        }
        else {
            worksheet.setDataSource(InfoWorkbook.dataSources);
        }
        worksheet.bindColumns(InfoWorkbook.headerColumns)
        worksheet.defaults.rowHeight = 25;
        worksheet.defaults.colHeaderRowHeight = 25;
        this.addFilter(worksheet);
    }

    /**
     * Chuyển đổi từ dữ liệu gốc qua dataSources
     * @param {*} dataTree  dữ liệu gốc dạng cha con
     * @returns 
     */
    mapDataSourcesByDataTree(dataTree) {
        let dataSources = [];
        if (!dataTree || dataTree.length === 0) return null;
        dataTree = this.sortDataTree(dataTree);
        dataTree.forEach(item => {
            let dataItem = {
                code: item.code,
                group: item.group
            }
            dataItem['name' + item.grade] = item.name;
            dataSources.push(dataItem);
        });
        return dataSources;
    }

    /**
    * Hàm check trùng lặp
      tvtam
    */
    addDuplicateRuleColumn = (activeSheet, colIndex) => {
        let style = new GC.Spread.Sheets.Style();
        style.backColor = 'yellow';
        let ranges = [new GC.Spread.Sheets.Range(-1, colIndex, -1, 1)];
        activeSheet.conditionalFormats.addDuplicateRule(style, ranges);
    };

    /**
     * set style mặc định cho worksheet
     * @param {*} worksheet 
     */
    setStyleDefault(worksheet) {
        worksheet.defaults.rowHeight = 25;
        worksheet.defaults.colHeaderRowHeight = 25;
        let rowCol = worksheet.getRowCount(),
            colCount = worksheet.getColumnCount();
        style = new GC.Spread.Sheets.Style();

    }

    /**
     * Gen lại data sau khi insert column
     * @param {*} worksheet 
     * @param {*} args 
     */
    genDataAfterInsertColumn(worksheet) {
        let dataSoruce = worksheet.getDataSource();
        let colCount = worksheet.getColumnCount();
        let key = 'name' + (colCount - 1).toString();
        dataSoruce = dataSoruce.map(obj => {
            return {
                ...obj,    // giữ nguyên các key hiện có
                [key]: ""   // thêm key mới với giá trị rỗng
            };
        });
        return dataSoruce;
    }

    /**
     * Render lại sau khi thêm nhiệm vụ chi tiết
     * @param {*} worksheet 
     */
    reRenderWorkbookAddColumn(wb, options = null) {
        let worksheet = wb.getActiveSheet();
        let colCount = worksheet.getColumnCount();
        const InfoWorkbook = this.genHeaderColumnsAndDataSources(colCount - 1);
        let dataSoruce = this.genDataAfterInsertColumn(worksheet);
        //this.addDuplicateRuleColumn(worksheet, 0);
        if (dataSoruce) {
            worksheet.setDataSource(dataSoruce);
        }
        else {
            worksheet.setDataSource(InfoWorkbook.dataSources);
        }
        worksheet.bindColumns(InfoWorkbook.headerColumns)
    }

    /**
     * 
     * Chuyển đổi key của mảng đối tượng
     * @param {*} array  mảng đối tương cần chuyển đổi 
     * array = [
    { oldKey1: 'value1', oldKey2: 'valueA' },
    { oldKey1: 'value2', oldKey2: 'valueB' }
    ];
     * @param {*} keyMap Đối tượng keyMap chứa key cũ và key mới
     * @param {*} modes clear các key khác trong key map

     keyMap = {
    oldKey1: 'newKey1',
    oldKey2: 'newKey2'
    };
     * @returns 
    [
   { newKey1: 'value1', newKey2: 'valueA' },
   { newKey1: 'value2', newKey2: 'valueB' }
    ]
     */
    renameKeys(array, keyMap, modes = false) {
        return array.map(obj => {
            let newObj = {};

            // Duyệt qua từng key trong đối tượng
            for (let key in obj) {
                if (keyMap[key]) {
                    // Nếu key có trong keyMap, đổi tên và thêm vào newObj
                    newObj[keyMap[key]] = obj[key];
                } else if (!modes) {
                    // Nếu modes == false, giữ nguyên các key không có trong keyMap
                    newObj[key] = obj[key];
                }
            }
            return newObj;
        });
    }

    getDataByWorkbook(worksheet) {
        let data = worksheet.getDataSource();
        const keyMap = {
            parentName: 'parent',
            name: 'name',
            code: 'regular_code',
            grade: 'Grade',
            regular_group_name: 'group',
        }
        data = this.convertDataToTree(data);
        data = this.renameKeys(data, keyMap);

        return data;
    }
    /**
     * Chuyển đổi về dạnh cha con để lưu
     * @param {array} data dữ liệu lấy ra từ workbook
     */
    convertDataToTree(data) {
        let dataSave = [];
        let parentName = [];
        data.forEach(item => {
            let dataItem = {
                code: item.code,
                regular_group_name: item.group
            }
            item = this.clearEmptyValues(item);
            for (let key in item) {
                if (key.includes('name')) {
                    let grade = key.replace('name', '');
                    dataItem['name'] = item[key];
                    dataItem['grade'] = grade;
                    if (parentName.length < grade) {
                        parentName.push({ code: item.code, name: item[key], grade: grade, sort: item.code })
                    }
                    else {
                        parentName[grade - 1] = { code: item.code, name: item[key], grade: grade, sort: item.code };
                    }
                    if (grade > 1) {
                        dataItem['parentName'] = parentName[grade - 2].name;
                    }
                }
            }
            dataSave.push(dataItem);
        });
        return dataSave;
    }

    /**
     * Xóa các thuộc tính không có giá trị
     * @param {*} obj 
     * @returns 
     */
    clearEmptyValues(obj) {
        for (let key in obj) {
            if (!obj[key] || obj[key] == null || obj[key] == undefined || obj[key].toString().trim() == "") {
                delete obj[key];
            }
        }
        return obj;
    }
    /**
     * tạo bộ lọc cho tất cả cột của sheet
     * @param {*} sheet 
     */
    addFilter(sheet) {
        sheet.rowFilter(
            new GC.Spread.Sheets.Filter.HideRowFilter(
                new GC.Spread.Sheets.Range(0, 0, sheet.getRowCount(), sheet.getColumnCount()),
            ),
        );
    };

}

export default new MISAWorkbookAvaHelper();
